import React, { useState, useEffect } from 'react'
import { getIssaugotos, perjungtiIssaugota } from '../utils/issaugotos'

const KATEGORIJU_PAVADINIMAI = {
  gamta: 'Gamta', 'jūra': 'Jūra', jura: 'Jūra', istorija: 'Istorija', miestas: 'Miestas', veikla: 'Veikla',
}

function IssaugotosVietos({ atidaryta, onClose, onVietaPasirinkta }) {
  const [sarasas, setSarasas] = useState([])

  useEffect(() => {
    if (atidaryta) setSarasas(getIssaugotos())
  }, [atidaryta])

  function pasalinti(e, vieta) {
    e.stopPropagation()
    perjungtiIssaugota(vieta)
    setSarasas(getIssaugotos())
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1002, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 380ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '18px 20px 14px', borderBottom: '1px solid #2A3B32' }}>
        <button
          onClick={onClose}
          aria-label="Atgal"
          style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'transparent', border: '1px solid #3A4C42', color: '#F0E8D5', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <h1 style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: '22px', fontWeight: 500, margin: 0 }}>Išsaugotos vietos</h1>
      </div>

      {/* Turinys */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 16px 24px' }}>
        {sarasas.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70%', textAlign: 'center', padding: '0 30px' }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#3A4C42" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
              <path d="M19 21l-7-5-7 5V5.2c0-1.2.9-2.2 2-2.2h10c1.1 0 2 1 2 2.2z" />
            </svg>
            <p style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: '18px', margin: '0 0 8px' }}>Dar nieko neišsaugojai</p>
            <p style={{ color: '#7A8A7E', fontSize: '13px', lineHeight: 1.5, margin: 0 }}>Bakstelk širdį prie vietos, kad ją čia rastum vėliau.</p>
          </div>
        ) : (
          sarasas.map(vieta => {
            const nuotr = vieta.nuotraukos?.[0] || vieta.nuotrauka_url
            return (
              <div
                key={vieta.id}
                onClick={() => onVietaPasirinkta(vieta)}
                style={{ display: 'flex', gap: '12px', alignItems: 'center', padding: '10px 6px', borderBottom: '1px solid #2A3B32', cursor: 'pointer' }}
              >
                <div style={{ width: '72px', height: '72px', borderRadius: '8px', overflow: 'hidden', background: '#1E2E27', flexShrink: 0 }}>
                  {nuotr && <img src={nuotr} alt={vieta.pavadinimas} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ color: '#7A8A7E', fontSize: '11px', margin: '0 0 3px' }}>{KATEGORIJU_PAVADINIMAI[vieta.kategorija] || vieta.kategorija}</p>
                  <p style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: '15px', fontWeight: 500, margin: 0, lineHeight: 1.2 }}>{vieta.pavadinimas}</p>
                </div>
                <button
                  onClick={(e) => pasalinti(e, vieta)}
                  aria-label="Pašalinti iš išsaugotų"
                  style={{ width: '34px', height: '34px', borderRadius: '50%', background: 'rgba(229,168,64,0.14)', border: '1px solid rgba(229,168,64,0.35)', color: '#E5A840', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#E5A840" stroke="#E5A840" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21l-7-5-7 5V5.2c0-1.2.9-2.2 2-2.2h10c1.1 0 2 1 2 2.2z" /></svg>
                </button>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

export default IssaugotosVietos
